import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { useSettingsContext } from '../context';

export const GZAVNILI_MODES = {
  online: 'online',
  physical: 'physical',
};

export default function GzavniliMode() {
  const settings = useSettingsContext();

  const value = settings.gzavniliMode || GZAVNILI_MODES.online;

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      color="primary"
      value={value}
      onChange={(event, newValue) => {
        if (newValue) settings.onUpdate('gzavniliMode', newValue);
      }}
      sx={{ height: 40, '& .MuiToggleButton-root': { px: 2, fontWeight: 600 } }}
    >
      <ToggleButton value={GZAVNILI_MODES.online}>Online</ToggleButton>
      <ToggleButton value={GZAVNILI_MODES.physical}>Physical</ToggleButton>
    </ToggleButtonGroup>
  );
}
